import { take, call, put } from 'redux-saga/effects';

import {
  types,
  fetchTutorStatisticSuccess,
  fetchTutorStatisticFailed,
} from '../redux/tutorStatic';
import apis from '../apis/chat';

export default function* () {
  while (true) {
    const {
      payload: { tutorID },
    } = yield take(types.FETCH_TUTOR_STATISTIC);

    try {
      const response = yield call(apis.getTutorStatics, tutorID);

      const { subject_categories: subjects } = response.data;

      const sortedSubjects = subjects.sort(
        (a, b) => b.question_count - a.question_count
      );

      const topSubjects = sortedSubjects.slice(0, 3);

      yield put(fetchTutorStatisticSuccess(topSubjects));
    } catch (err) {
      yield put(fetchTutorStatisticFailed(err));
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/tutorStatic.js